import { AgeTypeOptions, FootballTypeOptions, GenderOptions, TeamTypeOptions } from 'common/dto-types/team-dto';
import { Column } from 'react-table';
import { SelectColumnFilter } from 'utils/react-table';
import GenderCell from './team-table-cells/gender-cell';
import FootballTypeCell from './team-table-cells/football-type-cell';
import AgeTypeCell from './team-table-cells/age-type-cell';
import TeamTypeCell from './team-table-cells/team-type-cell';

const TeamTableColumnConfig: Column[] = [
    {
        Header: 'Id',
        accessor: 'id',
    },
    {
        Header: 'Name',
        accessor: 'name',
    },
    {
        Header: 'Age Type',
        accessor: 'ageType',
        Filter: (props) => <SelectColumnFilter {...props} options={AgeTypeOptions} />,
        Cell: AgeTypeCell,
    },
    {
        Header: 'Team Type',
        accessor: 'teamType',
        Filter: (props) => <SelectColumnFilter {...props} options={TeamTypeOptions} />,
        Cell: TeamTypeCell,
    },
    {
        Header: 'Football Type',
        accessor: 'footballType',
        Filter: (props) => <SelectColumnFilter {...props} options={FootballTypeOptions} />,
        Cell: FootballTypeCell,
    },
    {
        Header: 'Gender',
        accessor: 'gender',
        Filter: (props) => <SelectColumnFilter {...props} options={GenderOptions} />,
        Cell: GenderCell,
    },
    {
        Header: 'Abbreviation',
        accessor: 'abbreviation',
    },
];

export default TeamTableColumnConfig;

export const DefaultVisibleTeamColumns = [
    'id',
    'name',
    'ageType',
    'teamType',
    'footballType',
    'gender',
    'abbreviation',
];

export const SearchableTeamTableColumnConfig = ['id', 'name'];
